"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Formula = exports.FormulaOutputType = void 0;

var _dotObject = _interopRequireDefault(require("dot-object"));

var _lodash = _interopRequireDefault(require("lodash.clonedeep"));

var _mathjs = require("mathjs");

var _consts = require("../consts");

var _unitsMath = require("../utils/units-math");

var _math = require("./math");

var _types = require("./types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var FormulaOutputType;
exports.FormulaOutputType = FormulaOutputType;

(function (FormulaOutputType) {
  FormulaOutputType[FormulaOutputType["TEXT"] = _consts.ColumnType.TEXT] = "TEXT";
  FormulaOutputType[FormulaOutputType["NUMBER"] = _consts.ColumnType.NUMBER] = "NUMBER";
  FormulaOutputType[FormulaOutputType["BOOLEAN"] = _consts.ColumnType.BOOLEAN] = "BOOLEAN";
})(FormulaOutputType || (exports.FormulaOutputType = FormulaOutputType = {}));

function isRecord(term) {
  return _typeof(term) === 'object' && !(0, _types.isUnitAwareNumber)(term) && term !== null;
}

function isUnit(result) {
  if (_typeof(result) !== 'object' || result === null) return false;
  return typeof result.hasBase === 'function';
}

function roundoff(number) {
  return parseFloat(_math.math.format(number, {
    precision: 14
  }));
}

var Formula = /*#__PURE__*/function () {
  function Formula() {
    _classCallCheck(this, Formula);
  }

  _createClass(Formula, null, [{
    key: "evaluate",
    value: function evaluate(expression, record, units) {
      this.resetUnitsForNextExpression();
      var terms;

      if (record) {
        var termsInUse = this.filterUnusedTerms(record, expression);
        terms = this.parseTerms(termsInUse);
      }

      var result = terms ? _math.math.evaluate(expression, terms) : _math.math.evaluate(expression);

      if (units) {
        result = _math.math.to(result, units);
      }

      if (isUnit(result)) {
        var mathJSON = this.isExplicitUnitConversion(expression) ? result.toJSON() : result.simplify().toJSON();
        var value = mathJSON.value,
            unit = mathJSON.unit;
        return {
          value: roundoff(value),
          unit: unit
        };
      }

      return result;
    }
    /*
     * We are using "auto" unit system, meaning when simplifying mathjs will use units that were used in an expression.
     * There is only one mathjs instance, and to avoid using units from previous expression evaluation, we reset them.
     * Without reset we can end up in the following situation:
     *    expression 1: "10 PPM/s * 2 s = 12 PPM"
     *    expression 2: "30 mg / 2 L = 15 PPM"
     * Note that the second expression output in "PPM" instead of "mg/L". This is undesirable behaviour because
     * PPM is used to describe special concentration use cases.
     *
     * Note: units that are defined in an expression's *terms* are not treated differently than units used in the
     * expression itself. So even if you don't *use* a particular unit in an expression, merely passing it as a
     * term will potentially alter the output from the expression, causing it to perform undesired unit "simplification"
     */

  }, {
    key: "resetUnitsForNextExpression",
    value: function resetUnitsForNextExpression() {
      var UNIT_SYSTEMS = _math.math.Unit.UNIT_SYSTEMS; // Seeding unit system with imperial units

      UNIT_SYSTEMS.auto = JSON.parse(JSON.stringify(UNIT_SYSTEMS.us));

      _math.math.Unit.setUnitSystem('auto');
    }
  }, {
    key: "determineOutput",
    value: function determineOutput(expression, terms) {
      var output = Formula.evaluate(expression, terms);
      if (output === null) return null; // eslint-disable-next-line default-case

      switch (_typeof(output)) {
        case 'string':
          return {
            type: FormulaOutputType.TEXT,
            units: null
          };

        case 'boolean':
          return {
            type: FormulaOutputType.BOOLEAN,
            units: null
          };

        case 'number':
          return {
            type: FormulaOutputType.NUMBER,
            units: null
          };
        // eslint-disable-next-line no-fallthrough

        case 'object':
          if ((0, _types.isUnitAwareNumber)(output)) {
            return {
              type: FormulaOutputType.NUMBER,
              units: output.unit
            };
          }

      }

      throw new Error("Unexpected formula output ".concat(_typeof(output), " for expression ").concat(expression));
    }
  }, {
    key: "isValid",
    value: function isValid(expression, sampleTerms) {
      var messagePrefix = 'Formula is invalid:';

      if (!expression) {
        return {
          ok: false,
          message: "".concat(messagePrefix, " Missing expression")
        };
      }

      try {
        var output = Formula.validateCanBeRunAndDetermineOutput(expression, sampleTerms);
        this.validateMapistryRules(expression);
        this.validateAllTernaryExpressions(expression, sampleTerms);
        return {
          ok: true,
          output: output
        };
      } catch (e) {
        if (e instanceof Error || typeof e === 'string') {
          return {
            ok: false,
            message: "".concat(messagePrefix, " ").concat(e instanceof Error ? e.message : e)
          };
        }

        return {
          ok: false,
          message: "".concat(messagePrefix, " An unknown error occurred")
        };
      }
    }
  }, {
    key: "validateCanBeRunAndDetermineOutput",
    value: function validateCanBeRunAndDetermineOutput(expression, terms) {
      // determineOutput method evaluates formula expression which performs regular mathjs validations
      var output = Formula.determineOutput(expression, terms);

      if (output == null) {
        throw new Error("Expression ".concat(expression, " must return a non-null value"));
      }

      return output;
    }
  }, {
    key: "validateMapistryRules",
    value: function validateMapistryRules(expression) {
      var _this = this;

      var rootNode = _math.math.parse(expression);

      rootNode.traverse(function (node) {
        _this.validateAllowedOperators(node);

        _this.validateAllowedFunctions(node);
      });
    }
  }, {
    key: "validateAllowedOperators",
    value: function validateAllowedOperators(node) {
      // "=" is an assignment operator which can be easily be confused with "==" comparison operator.
      // To avoid accidental mistakes, we are disallowing this operator in formulas since
      // currently there is no use case for creating variables and assigning values to them.
      if ((0, _mathjs.isAssignmentNode)(node)) {
        throw new Error('Invalid operator "=". To compare two numbers, use "==" or "equal()" function. To compare two strings, use "equalText()" function');
      }
    }
  }, {
    key: "validateAllowedFunctions",
    value: function validateAllowedFunctions(node) {
      var _this2 = this;

      // This functions compare two arguments, e.g. a1 and a2, and return -1 if a1 < a2, 0 if a1 = a2, and 1 if a1 > a2.
      // Currently, there is no use case for these function in our formulas, and it's easy to confuse them with
      // function that compare two values on equality and return true/false.
      ['compare', 'compareText'].forEach(function (funcName) {
        if (_this2.isMathFunction(node, funcName)) {
          throw new Error("Invalid function \"".concat(funcName, "\". To compare two numbers, use \"==\" or \"equal()\" function. To compare two strings, use \"equalText()\" function"));
        }
      });
    } // When evaluating a formula expression with ternary condition, mathjs will only go through
    // one of the condition branches, meaning that another branch won't be evaluated and can be invalid.
    // E.g. given "A ? B : C" expression and terms where "A" is evaluated to true, mathjs will only tell us
    // that B is valid, but C still might be not.

  }, {
    key: "validateAllTernaryExpressions",
    value: function validateAllTernaryExpressions(expression, sampleTerms) {
      var _this3 = this;

      var rootNode = _math.math.parse(expression);

      rootNode.traverse(function (node) {
        if ((0, _mathjs.isConditionalNode)(node)) {
          _this3.validateSingleConditionalNode(node, sampleTerms);
        }
      });
    }
  }, {
    key: "validateSingleConditionalNode",
    value: function validateSingleConditionalNode(node, sampleTerms) {
      var condition = node.condition,
          trueExpr = node.trueExpr,
          falseExpr = node.falseExpr;
      var trueExprTerms = this.updateTermsIfConditionChecksForNumericValue(condition, sampleTerms);
      var trueExprOutput = Formula.validateCanBeRunAndDetermineOutput(trueExpr.toString(), trueExprTerms);
      var falseExprOutput = Formula.validateCanBeRunAndDetermineOutput(falseExpr.toString(), sampleTerms);
      this.validateConditionalNodeOutputTypes(condition, trueExprOutput, falseExprOutput);
      this.validateConditionalNodeUnits(condition, trueExprOutput, falseExprOutput);
    } // This method covers a special case when users log numeric values or a special text
    // in the same field, e.g. "Not Detected". They will use a text field for that. Then in a formula,
    // they will check whether a value is a number and convert that string to a number, or use default number
    // otherwise, e.g. "hasNumericValue(NUMBER_OR_ND) ? numeric(NUMBER_OR_ND) : 0".
    // If we detect that ternary condition is "hasNumericValue" function, we update a value of a variable
    // that a user checks to be a number disguised as a string, e.g. NUMBER_OR_ND = "1234".
    // This way we can correctly validate true branch of ternary because "numeric" function throws if it's given
    // anything but a string containing only a number.

  }, {
    key: "updateTermsIfConditionChecksForNumericValue",
    value: function updateTermsIfConditionChecksForNumericValue(condition, sampleTerms) {
      if (!sampleTerms || !this.isMathFunction(condition, 'hasNumericValue')) {
        return sampleTerms;
      }

      var maybeNumericNode = condition.args[0]; // SymbolNode – variable without dot notation, AccessorNode – with dot notation, e.g. GENERATOR.SERIAL_NUMBER

      var isVariable = (0, _mathjs.isSymbolNode)(maybeNumericNode) || (0, _mathjs.isAccessorNode)(maybeNumericNode);

      if (condition.args.length > 1 || !isVariable) {
        throw new Error('hasNumericValue function accepts a single argument which must be a variable');
      }

      var maybeNumericVariable = maybeNumericNode.toString();
      var sampleTermsCopy = (0, _lodash["default"])(sampleTerms); // Will set value for our path with dot notation correctly.
      // E.g. if `maybeNumericVariable` is "GENERATOR.SERIAL_NUMBER",
      // the value for sampleTermsCopy.GENERATOR.SERIAL_NUMBER will be set to '1234'

      _dotObject["default"].set(maybeNumericVariable, '1234', sampleTermsCopy);

      return sampleTermsCopy;
    }
  }, {
    key: "validateConditionalNodeOutputTypes",
    value: function validateConditionalNodeOutputTypes(condition, trueExprOutput, falseExprOutput) {
      var conditionMsg = "Condition: \"".concat(condition.toString(), "\"");

      if (trueExprOutput.type !== falseExprOutput.type) {
        throw new Error("Conditional expression must always output the same type, but output is ".concat(trueExprOutput.type, " if it's true, and ").concat(falseExprOutput.type, " if it's false. ").concat(conditionMsg));
      }
    }
  }, {
    key: "validateConditionalNodeUnits",
    value: function validateConditionalNodeUnits(condition, trueExprOutput, falseExprOutput) {
      var conditionMsg = "Condition: \"".concat(condition.toString(), "\"");
      var unitsMsg = 'Conditional expression must always output in related units';

      if (!trueExprOutput.units && falseExprOutput.units) {
        throw new Error("".concat(unitsMsg, ", but output is just a number if condition is true. ").concat(conditionMsg));
      }

      if (trueExprOutput.units && !falseExprOutput.units) {
        throw new Error("".concat(unitsMsg, ", but output is just a number if condition is false. ").concat(conditionMsg));
      }

      if (trueExprOutput.units && falseExprOutput.units && !_unitsMath.MathUnit.areRelated(trueExprOutput.units, falseExprOutput.units)) {
        throw new Error("".concat(unitsMsg, ", but output is in ").concat(trueExprOutput.units, " if it's true, and in ").concat(falseExprOutput.units, " if it's false. ").concat(conditionMsg));
      }
    }
  }, {
    key: "isMathFunction",
    value: function isMathFunction(node, funcName) {
      return (0, _mathjs.isFunctionNode)(node) && (0, _mathjs.isSymbolNode)(node.fn) && node.fn.name === funcName;
    }
    /* An AccessorNode is dot notation. FOO.BAR.BAZ will result in:
    AccessorNode
      object: // FOO.BAR
        AccessorNode
          object: // FOO
            SymbolNode: Foo
          index:
            ConstantNode: BAR
      index:
        ConstantNode: BAZ
     */

  }, {
    key: "parseTermString",
    value: function parseTermString(node) {
      var index = node.index,
          object = node.object;
      var name;

      if ((0, _mathjs.isAccessorNode)(object)) {
        name = this.parseTermString(object);
      } else if ((0, _mathjs.isSymbolNode)(object)) {
        name = object.name;
      } else {
        throw new Error("Unknown node of type: ".concat(object.type));
      }

      var _index$dimensions = _slicedToArray(index.dimensions, 1),
          childNode = _index$dimensions[0];

      if (!childNode) return name; // Reached the bottom, return

      if ((0, _mathjs.isConstantNode)(childNode)) {
        return "".concat(name, ".").concat(childNode.value);
      }

      return name;
    }
    /**
     * Return a list of terms used in the expression.
     * Warning: this method currently returns not just Mapistry-provided terms like "USER.EMAIL" or "GENERATOR.NAME", but
     * additionally, method names, such as `RUNTIME.toNumber`. These were difficult to filter out from the list, and should not be used.
     *
     * Example result for expression: USAGE * GENERATOR.VOC + GENERATOR.CRUSHER.ENGINE.EMISSION_FACTOR - GENERATOR.CRUSHER.EMISSION_FACTOR
     *
     * {
     *   "mathjs": "OperatorNode",
     *   "op": "-",
     *   "fn": "subtract",
     *   "args": [
     *     {
     *       "mathjs": "OperatorNode",
     *       "op": "+",
     *       "fn": "add",
     *       "args": [
     *         {
     *           "mathjs": "OperatorNode",
     *           "op": "*",
     *           "fn": "multiply",
     *           "args": [
     *             {
     *               "mathjs": "SymbolNode",
     *               "name": "USAGE"
     *             },
     *             {
     *               "mathjs": "AccessorNode",
     *               "object": {
     *                 "mathjs": "SymbolNode",
     *                 "name": "GENERATOR"
     *               },
     *               "index": {
     *                 "mathjs": "IndexNode",
     *                 "dimensions": [
     *                   {
     *                     "mathjs": "ConstantNode",
     *                     "value": "VOC"
     *                   }
     *                 ],
     *                 "dotNotation": true
     *               }
     *             }
     *           ],
     *           "implicit": false,
     *           "isPercentage": false
     *         },
     *         {
     *           "mathjs": "AccessorNode",
     *           "object": {
     *             "mathjs": "AccessorNode",
     *             "object": {
     *               "mathjs": "AccessorNode",
     *               "object": {
     *                 "mathjs": "SymbolNode",
     *                 "name": "GENERATOR"
     *               },
     *               "index": {
     *                 "mathjs": "IndexNode",
     *                 "dimensions": [
     *                   {
     *                     "mathjs": "ConstantNode",
     *                     "value": "CRUSHER"
     *                   }
     *                 ],
     *                 "dotNotation": true
     *               }
     *             },
     *             "index": {
     *               "mathjs": "IndexNode",
     *               "dimensions": [
     *                 {
     *                   "mathjs": "ConstantNode",
     *                   "value": "ENGINE"
     *                 }
     *               ],
     *               "dotNotation": true
     *             }
     *           },
     *           "index": {
     *             "mathjs": "IndexNode",
     *             "dimensions": [
     *               {
     *                 "mathjs": "ConstantNode",
     *                 "value": "EMISSION_FACTOR"
     *               }
     *             ],
     *             "dotNotation": true
     *           }
     *         }
     *       ],
     *       "implicit": false,
     *       "isPercentage": false
     *     },
     *     {
     *       "mathjs": "AccessorNode",
     *       "object": {
     *         "mathjs": "AccessorNode",
     *         "object": {
     *           "mathjs": "SymbolNode",
     *           "name": "GENERATOR"
     *         },
     *         "index": {
     *           "mathjs": "IndexNode",
     *           "dimensions": [
     *             {
     *               "mathjs": "ConstantNode",
     *               "value": "CRUSHER"
     *             }
     *           ],
     *           "dotNotation": true
     *         }
     *       },
     *       "index": {
     *         "mathjs": "IndexNode",
     *         "dimensions": [
     *           {
     *             "mathjs": "ConstantNode",
     *             "value": "EMISSION_FACTOR"
     *           }
     *         ],
     *         "dotNotation": true
     *       }
     *     }
     *   ],
     *   "implicit": false,
     *   "isPercentage": false
     * }
     */

  }, {
    key: "getTermsInUse",
    value: function getTermsInUse(expression) {
      var _this4 = this;

      var root = _math.math.parse(expression);

      var terms = [];
      root.traverse(function (node, path, parent) {
        // If the parent is an accessor node, we're already inside our parseTermString - don't reprocess a the child tree
        if (parent && (0, _mathjs.isAccessorNode)(parent)) return;

        if ((0, _mathjs.isFunctionNode)(node)) {
          var term = _this4.parseFunctionNodeTermString(node);

          term && terms.push(term);
        }

        if ((0, _mathjs.isAccessorNode)(node)) {
          terms.push(_this4.parseTermString(node));
        }

        if ((0, _mathjs.isSymbolNode)(node)) {
          terms.push(node.name);
        }
      });
      return terms;
    }
  }, {
    key: "convertExceptionalNumbersToNull",
    value: function convertExceptionalNumbersToNull(formulaOutputValue) {
      var value = (0, _types.isUnitAwareNumber)(formulaOutputValue) ? formulaOutputValue.value : formulaOutputValue;

      if (value === Infinity || value === -Infinity || Number.isNaN(value)) {
        return null;
      }

      return formulaOutputValue;
    }
    /**
     * This message helps make sure that terms like `GENERATOR.FACTOR.toNumber()` return GENERATOR.FACTOR.
     * These nodes are first accessed by the `toNumber` Function node.
     * This node would NOT have GENERATOR.FACTOR as a parent.
     * Instead, it is the accessor node hanging off of node.fn.object. This method allows us to parse the function node
     * to get the dot notation accessor.
     */

  }, {
    key: "parseFunctionNodeTermString",
    value: function parseFunctionNodeTermString(node) {
      if (!(0, _mathjs.isAccessorNode)(node.fn)) return undefined;
      var mathNode = node.fn.object;
      if ((0, _mathjs.isSymbolNode)(mathNode)) return mathNode.name;
      if ((0, _mathjs.isAccessorNode)(mathNode)) return this.parseTermString(mathNode);
      return undefined;
    } // determine if the parent + children all match with terms array

  }, {
    key: "isNodeAMatch",
    value: function isNodeAMatch(node, terms) {
      if ((0, _mathjs.isConstantNode)(node)) {
        return terms.length === 1 && typeof node.value === 'string' && terms[0] === node.value;
      }

      if ((0, _mathjs.isSymbolNode)(node)) {
        return terms.length === 1 && terms[0] === node.name;
      }

      if ((0, _mathjs.isAccessorNode)(node)) {
        var index = node.index,
            object = node.object;

        var _index$dimensions2 = _slicedToArray(index.dimensions, 1),
            childNode = _index$dimensions2[0];

        if (!childNode || terms.length < 2) return false;
        var lastTerm = terms[terms.length - 1];
        var rest = terms.slice(0, terms.length - 1);
        return this.isNodeAMatch(childNode, [lastTerm]) && this.isNodeAMatch(object, rest);
      }

      return false;
    }
  }, {
    key: "replaceTermInExpression",
    value: function replaceTermInExpression(expression, replaceTerm, withTerm) {
      var _this5 = this;

      var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        preserveNesting: true
      },
          preserveNesting = _ref.preserveNesting;

      var root = _math.math.parse(expression);

      var replaceTerms = replaceTerm.split('.');
      var withTerms = withTerm.split('.');

      if (preserveNesting && replaceTerms.length !== withTerms.length) {
        throw new Error("Cannot replace the term ".concat(replaceTerm, " with the term ").concat(withTerm, ": terms do not have the same level of nesting (").concat(replaceTerms.length, " vs ").concat(withTerms.length, ")"));
      }

      var newRoot = root.transform(function (node, path, parent) {
        // Check that parent is not an index node so we don't match BAR with FOO.BAR
        if (!(0, _mathjs.isIndexNode)(parent) && _this5.isNodeAMatch(node, replaceTerms)) {
          return _math.math.parse(withTerm);
        }

        return node;
      });
      return newRoot.toString();
    }
  }, {
    key: "isExplicitUnitConversion",
    value: function isExplicitUnitConversion(expression) {
      var root = _math.math.parse(expression);

      var finalNode;
      root.traverse(function (node) {
        // the first node in the tree traversal is the "final node" in terms of the expression.
        // I.e. the expression `(bunch * of - stuff) to km` would parse "to km" as the first operation in the tree
        if (!finalNode) {
          finalNode = node;
        }
      });
      var finalOperation = (0, _mathjs.isOperatorNode)(finalNode) ? finalNode : undefined;
      return (finalOperation === null || finalOperation === void 0 ? void 0 : finalOperation.op) === 'to';
    }
    /**
     * Standardize whitespace and formatting differences for an expression
     */

  }, {
    key: "format",
    value: function format(expression) {
      return _math.math.parse(expression).toString();
    }
  }, {
    key: "parseTerms",
    value: function parseTerms(record) {
      var _this6 = this;

      return Object.entries(record).reduce(function (it, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            val = _ref3[1];

        var value;

        if (isRecord(val)) {
          // recurse
          value = _this6.parseTerms(val);
        } else if ((0, _types.isUnitAwareNumber)(val) && val.unit !== null && val.value !== null) {
          value = _math.math.unit(val.value, val.unit);
        } else {
          value = val;
        }

        return _objectSpread(_objectSpread({}, it), {}, _defineProperty({}, key, value));
      }, {});
    }
  }, {
    key: "filterUnusedTerms",
    value: function filterUnusedTerms(termsObject, expression) {
      var termsInUse = this.getTermsInUse(expression);
      var filteredTerms = {};
      termsInUse.forEach(function (dotNotationTerm) {
        _dotObject["default"].copy(dotNotationTerm, dotNotationTerm, termsObject, filteredTerms);
      });
      return filteredTerms;
    }
  }]);

  return Formula;
}();

exports.Formula = Formula;